import {useMutation} from "@tanstack/react-query";

import {editRepresentativeCommissionMutationOptions} from "./edit-representative-commission.mutation-options";

export function useEditRepresentativeCommission(representativeId: string, commissionId: number) {
  return useMutation(editRepresentativeCommissionMutationOptions(representativeId, commissionId));
}
